<template>
  <div class="main">
    <el-row style="margin-top:-6px;">
      <el-col :span="12">
         <New4Index></New4Index>
      </el-col>
      <el-col :span="12">
   <New4Quantity></New4Quantity>
      </el-col>
    </el-row>
    
    <el-row>
      <el-col :span="12">
     <NewCarMonitor></NewCarMonitor>
             <BodyTypeMonthlySale></BodyTypeMonthlySale>
      </el-col>
      <el-col :span="12">  
        <CurrentMonthlyNewCar></CurrentMonthlyNewCar>
     <ProvinceChart></ProvinceChart>
      </el-col>
     
    </el-row>
    <el-row>
 <el-col :span="12">

      </el-col>
 <el-col :span="12">
            
      </el-col>
    </el-row>
   
    <el-row>
      <el-col :span="12"></el-col>
      <el-col :span="12"></el-col>
    </el-row>
  </div>
</template>
 
<script>
import { mapMutations, mapGetters, mapActions, mapState } from "vuex";
import New4Quantity from "@/components/charts/New4Quantity.vue";
import Permissions from "@/store/permissions.js";
import ProvinceChart from "@/components/charts/ProvinceChart.vue";
import New4Index from "@/components/charts/New4Index.vue";
import NewCarMonitor from "@/components/charts/NewCarMonitor.vue";
import BodyTypeMonthlySale from "@/components/charts/BodyTypeMonthlySale.vue";
import CurrentMonthlyNewCar from "@/components/charts/CurrentMonthlyNewCar.vue";
export default {
  name: "home",
  components: {
    New4Quantity,
    ProvinceChart,
    New4Index,
    NewCarMonitor,
    BodyTypeMonthlySale,
    CurrentMonthlyNewCar
  },
  data() {
    return {};
  },
  methods: {},
  computed: {
    ...mapState({
      isLoading: state => state.loadingCount > 0
    })
  },
  mounted() {
    //   alert(Permissions['Pages.Users']);
  }
};
</script>

